import React, { useEffect, useState } from "react";
import axios from "axios";
import { Modal } from "flowbite";
import toast from 'react-hot-toast'
import { useNavigate } from "react-router-dom";

const AfroBonus = () => {

    const token = sessionStorage.getItem("bearer_token");
    const auth_token = sessionStorage.getItem("token");
    const [afroBonusEvents, setAfroBonusEvents] = useState([]);


    const navigate = useNavigate();

    const permissions = JSON.parse(sessionStorage.getItem("permissions"));

    const [permissionModule, setPermissionModule] = useState([]);

    const [filters, setFilters] = useState({
        email: "",
        page: 1,
        limit: 10,
    });
    const [pagination, setPagination] = useState({
        totalRecords: 0,
        currentPage: 1,
        totalPages: 0,
        limit: 0,
    });


    useEffect(() => {
        const getAfroBonusEvents = async () => {
            const queryParams = Object.entries(filters)
                .filter(([_, value]) => value) // Only include parameters with non-empty values
                .map(([key, value]) => `${key}=${encodeURIComponent(value)}`)
                .join("&");
            try {
                const res = await axios.get(process.env.REACT_APP_API_URL + `api/afroBonus/get-afroBonusEvents?${queryParams}`, {
                    headers: {
                        "Content-Type": "application/json",
                        "Authorization": `Bearer ${token}`,
                        "auth_token": `${auth_token}`,
                    },
                });

                if (res.data.success) {
                    setAfroBonusEvents(res.data.bonusEvents);
                    setPagination({
                        totalRecords: res.data.pagination.totalRecords,
                        currentPage: res.data.pagination.currentPage,
                        totalPages: res.data.pagination.totalPages,
                        limit: res.data.pagination.limit,
                    });
                } else {
                    setAfroBonusEvents([]);
                }


            }
            catch (err) {
                if (err.response?.status === 400) {
                    // Handle invalid token error
                    if (err.response.data === "invalid token") {
                        navigate("/login"); // Redirect to login page
                    } else {
                        toast.error(err.response.data); // Show other 400 errors
                    }
                } else {
                    // Handle other errors
                    toast.error("No Tickets Found!");
                }
            }
        }
        getAfroBonusEvents();
        if (permissions) {

            setPermissionModule(permissions.find(
                (permission) => permission.Module.moduleName === 'afroBonus'
            ));
        }

    }, [filters]);

    // search and pagination
    const handleFilterChange = (key, value) => {
        setFilters((prev) => ({
            ...prev,
            [key]: value,
            page: 1, // Reset to the first page on filter change
        }));
    };

    const handlePageChange = (newPage) => {
        setFilters((prev) => ({ ...prev, page: newPage }));
    };

    const formatDate = (dateString) => {
        const date = new Date(dateString.replace(" ", "T")); // Replace space with T for compatibility
        const options = { month: 'long', day: 'numeric', year: 'numeric' };
        const formattedDate = date.toLocaleDateString('en-US', options);
        const time = date.toLocaleTimeString('en-US', { hour12: false });
        return `${formattedDate} ${time}`;
    };

    const renderStatus = (status) => {
        switch (status) {
            case 'new':
                return (
                    <p className="bg-[#DEF7EC] text-sm text-[#03543F] px-3 py-1 rounded-full md:w-full text-center">New</p>

                );
            case 'existing':
                return (
                    <p className="bg-[#0379f8] text-sm text-white px-3 py-1 rounded-full md:w-full text-center">
                        Existing
                    </p>
                );
            default:
                return (
                    <p className="bg-[#0379f8] text-sm text-white px-3 py-1 rounded-full md:w-full text-center">
                        Existing
                    </p>
                );
        }
    }

    const renderProcessStatus = (status) => {
        switch (status) {
            case "pending_registration":
                return (
                    <p className="bg-[#FEF3C7] text-sm text-[#92400E] px-3 py-1 rounded-full md:w-full text-center">
                        Pending Registration
                    </p>
                );

            case "received":
                return (
                    <p className="bg-[#DBEAFE] text-sm text-[#1D4ED8] px-3 py-1 rounded-full md:w-full text-center">
                        Received
                    </p>
                );

            case "redeemed":
                return (
                    <p className="bg-[#EDE9FE] text-sm text-[#6D28D9] px-3 py-1 rounded-full md:w-full text-center">
                        Redeemed
                    </p>
                );

            case "used":
                return (
                    <p className="bg-[#DCFCE7] text-sm text-[#15803D] px-3 py-1 rounded-full md:w-full text-center">
                        Used
                    </p>
                );

            case "expired":
                return (
                    <p className="bg-[#F3F4F6] text-sm text-[#4B5563] px-3 py-1 rounded-full md:w-full text-center">
                        Expired
                    </p>
                );

            case "failed":
                return (
                    <p className="bg-[#FDE8E8] text-sm text-[#C81E1E] px-3 py-1 rounded-full md:w-full text-center">
                        Failed
                    </p>
                );

            default:
                return (
                    <p className="bg-gray-100 text-sm text-gray-700 px-3 py-1 rounded-full md:w-full text-center">
                        Unknown
                    </p>
                );
        }
    };

    return (
        <div className="bg-gray-100">
            <div className="py-20 p-4 sm:ml-64">

                <div className="md:flex justify-start py-5">

                    {/* Filters UI */}
                    <div className=" items-center md:flex gap-4">
                        <input
                            type="text"
                            placeholder="Search by Email"
                            value={filters.email}
                            onChange={(e) => handleFilterChange("email", e.target.value)}
                            className="my-1 md:my-0 flex border-2 rounded-full px-3 py-2"
                        />

                    </div>
                </div>

                <div className="w-full  p-4 bg-white border border-gray-200 rounded-lg shadow sm:p-8 dark:bg-gray-800 dark:border-gray-700">

                    <div className="flex justify-start">
                        <div className="flex flex-col text-left">
                            <h1 className="text-xl text-black font-bold">AfroBONUS</h1>

                        </div>

                    </div>

                    <div className="relative overflow-x-auto custom-scrollbar sm:rounded-lg mt-5">

                        <table className="w-full text-sm text-left rtl:text-right text-gray-500 dark:text-gray-400">
                            <thead className="text-xs text-gray-700 uppercase bg-gray-50 dark:bg-gray-700 dark:text-gray-400">
                                <tr>
                                    <th scope="col" className="px-6 py-3 whitespace-normal break-words">User Name</th>
                                    <th scope="col" className="px-6 py-3 whitespace-normal break-words">Email</th>
                                    <th scope="col" className="px-6 py-3 whitespace-normal break-words">Amount</th>
                                    <th scope="col" className="px-6 py-3 whitespace-normal break-words">Points Earned</th>
                                    <th scope="col" className="px-6 py-3 whitespace-normal break-words">Redeem Code</th>
                                    <th scope="col" className="px-6 py-3 whitespace-normal break-words">Date/Time</th>
                                    <th scope="col" className="px-6 py-3 whitespace-normal break-words">Expires In</th>
                                    <th scope="col" className="px-6 py-3 whitespace-normal break-words">User Type</th>
                                    <th scope="col" className="px-6 py-3 whitespace-normal break-words">Process Status</th>

                                </tr>
                            </thead>
                            <tbody>
                                {afroBonusEvents.length > 0 ? (
                                    permissionModule.canRead ? afroBonusEvents.map((event) => (
                                        <tr key={event.id} className="odd:bg-white odd:dark:bg-gray-900 even:bg-gray-50 even:dark:bg-gray-800 border-b dark:border-gray-700">

                                            <td className="px-6 py-4 whitespace-normal break-words">{event.name ? event.name : "N/A"}</td>
                                            <td className="px-6 py-4 whitespace-normal break-words">{event.email ? event.email : "N/A"}</td>
                                            <td className="px-6 py-4 whitespace-normal break-words">{event.amount ? event.amount : "0"}</td>
                                            <td className="px-6 py-4 whitespace-normal break-words">{event.bonusPointsEarned ? event.bonusPointsEarned : "0"}</td>
                                            <td className="px-6 py-4 whitespace-normal break-words">{event.bonusCode ? event.bonusCode : "N/A"}</td>
                                            <td className="px-6 py-4 whitespace-normal break-words">{formatDate(event.eventTime)}</td>
                                            <td className="px-6 py-4 whitespace-normal break-words">{formatDate(event.expiresAt)}</td>
                                            <td className="px-6 py-4 whitespace-normal break-words">{renderStatus(event.userType)}</td>
                                            <td className="px-6 py-4 whitespace-normal break-words">{renderProcessStatus(event.processStatus)}</td>

                                        </tr>

                                    )) : "Access Denied"
                                ) : (
                                    <tr>
                                        <td colSpan="8" className="text-center py-4 whitespace-normal break-words">No Tickets Found.</td>
                                    </tr>
                                )}

                            </tbody>
                        </table>


                        {/* Pagination */}
                        <div className="flex justify-center my-4">
                            <button
                                onClick={() => handlePageChange(filters.page - 1)}
                                disabled={filters.page === 1}
                                className="text-white py-1 px-4 bg-black rounded-full mx-1"
                            >
                                Previous
                            </button>
                            <span className="px-4 py-2 mx-1 font-medium">
                                Page {pagination.currentPage} of {pagination.totalPages}
                            </span>
                            <button
                                onClick={() => handlePageChange(filters.page + 1)}
                                disabled={filters.page === pagination.totalPages}
                                className="text-white py-1 px-4 bg-black rounded-full mx-1"
                            >
                                Next
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default AfroBonus;